module.exports = __webpack_public_path__ + "4038ab3ac30d51f91477f98a198f2dbb.svg";